import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getDiagnosedTreatmentOverview,
  type DiagnosedTreatmentOverviewResult,
} from '@services/api/dashboard/diagnosed-treatment.api'

export function useDiagnosedTreatmentOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<DiagnosedTreatmentOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getDiagnosedTreatmentOverview, {
    enabled,
    queued,
  })
}
